import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import { BasicSelect } from 'vue-search-select'
import DatePicker from 'vue2-datepicker'
import newreturnsmanifest from '../newreturnsmanifest'
import viewreturnsmanifest from '../viewreturnsmanifest'
import download from 'downloadjs'
import common_helper from '../../../../common_helper'

import {
  WebCam
} from "vue-web-cam"
export default {
  name: 'returnmanifest',
  components: {
    Pagination,
    Loader,
    BasicSelect,
    DatePicker,
    newreturnsmanifest,
    download,
    viewreturnsmanifest,
    WebCam
  },
  data: function () {
    return {
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      pageLimit: 10,
      showSelectWarehouse: false,
      WarehouseErr: '',
      showSelectClient: false,
      isLoading: false,
      is_Loading: false,
      resultCount: '',
      listClientData: [],
      listWarehouseData: [],
      changestatus: '',
      ClientErr: '',
      WarehouseErr: '',
      editModal: false,
      clientid: '',
      warehouseid:'',
      showReturnsManifestList: true,
      fromDateFlt:'',
      toDateFlt:'',
      returnsmanifestid:'',
      salesorderno:'',
      awbno:'',
      transporter:'',
      transportererr:'',
      transporterList:[],
      channelErrors: {},
      clientItem: {},
      warehouseItem: {},
      isClientTokenExpired: false,
      manifeststatus:'',
      isLoadingforxls: false,
      csvFieldsForXls: {},
      download: true,
      reportname:this.$t('returnManifest.returnManifest'),
      show: false,
      dataFilter2: '',
      listReportDataforxls: [],
      listReturnManifestDataCsv: [],
      listReturnManifestData: [],
      viewReturnsManifestList:true,
      totalRows:0,
      uploadReturnsManifest:false,
      selectfileFlag : false,
      cameraSection : false,
      fileSection : false,
      cameraImage : null,
      selectFirstDevice: true,
      screenshotFormat: "image/jpeg",
      isdisableValue: false,
      cameralist : '',
			file :'',
			showfileselect : false,
			showcameraselect : false,
			cameras : '',
      uploadedImagesCount : 0 ,
      screenshotFormat: "image/jpeg",
			playsinline: false,
			autoplay: true,
			imageCaptured : false,
      manifestid:'',
      currentDate: '',
      item: {
				value: '',
				text: ''
			},
      transporterList1:[],
      uploadedImages: [],
    }
  },
  created: function () { },
  filters: {
    moment: function (date) {
      if (!date) return '';
      return moment(date).format('DD-MM-YY HH:mm:ss');
    }
  },

  mounted() {
    this.calldateFunction();
    this.pageno = 0
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.userid = userdetail.userid;
    this.user_type = userdetail.utype;
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    if(this.clientid!=='undefined'){
      this.getTransporterList();
    }
    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        // this.getClientList();
        // this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.warehouseid = userdetail.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();
        break;

      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    }
  },
  methods: {
    // getClientList() {
    //   this.pageNo = this.totalPage = 0;
    //   if (window.localStorage.getItem("clientList") !== null) {
    //     var clientListEncrypt = window.localStorage.getItem('clientList');
    //     var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
    //     var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
    //     this.getClientSelectOptions(JSON.parse(plaintextclient));
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken');
    //     var myStr = userToken.replace(/"/g, '');
    //     axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //       'data': {},
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr,
    //       }
    //     })
    //       .then(result => {
    //         this.getClientSelectOptions(result.data.data)
    //       }, error => {
    //         console.error(error);
    //       });
    //   }
    // },
    // async getWarehouseList() {
    //   if (window.localStorage.getItem("warehouseList") !== null) {
    //     var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
    //     var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
    //     var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
    //     this.getWarehouseSelectOptions(JSON.parse(plaintextwarehouse));
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken')
    //     var myStr = userToken.replace(/"/g, '');
    //     this.pageno = 0;
    //     this.input = ({
    //       clientid: this.clientid,
    //     });

    //    await axios({
    //       method: 'POST',
    //       'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //       'data': this.input,
    //       headers: {
    //         'Authorization': 'Bearer ' + myStr
    //       }
    //     })
    //       .then(result => {
    //         this.getWarehouseSelectOptions(result.data.data);
    //       }, error => {
    //         console.error(error)
    //       })
    //   }
    // },
    // clientSelected(item) {
    //   this.clientItem = item;
    //   if (this.clientid != this.clientItem.value) {
    //     this.clientid = this.clientItem.value;
    //     this.Chanelsearch = '';
    //     this.salesChannelItem={};
    //     this.getChannelList();
    //     if (this.user_type != 'warehouse_user') {
    //       this.listWarehouseData = []
    //       this.warehouseid='';
    //       this.warehouseItem={};
    //       this.getWarehouseList();
    //     }
    //   }
    //   this.pageno = this.totalPage = 0;
    // },
    // warehouseSelected(item) {
    //   this.warehouseItem = item;
    //   this.warehouseid = item.value;
    //   this.pageno = this.totalPage = 0;
    //   if (this.warehouseid) {
    //     if (this.clientid) {
    //     } else {
    //       this.getClientList();
    //     }
    //   }
    // },
    calldateFunction() {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');

			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.toDateFlt = this.currentDate;
			this.fromDateFlt = dt;

		},
    // getTransporterList() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	axios({
		// 			method: 'GET',
		// 			'url': apiUrl.api_url + 'courierlistRTO',
		// 			'data': {
		// 				//clientid: window.localStorage.getItem("selectedClient")
		// 			},
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 		.then(result => {
		// 			this.transporterList = result.data.rows;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },
    onSelect(item) {
			// select option from parent component
			this.item = item
			this.transporter = item.text;

		},
    getTransporterList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
            let params= {
				     clientid: localStorage.getItem("selectedClient"),
             warehouseid:window.localStorage.getItem("selectedWarehouse"),
            }
            axios({
                method: 'GET',
                url:`${apiUrl.api_url}courierlistRTO/${params.clientid}/${params.warehouseid}`,
                headers: {
                  'Authorization': 'Bearer ' + myStr
                }
              })
            .then(result => {
              this.transporterList = result.data.data;
                        this.item = {
                            value: '',
                            text: ''
                        },
                        this.transporterList1 = [{ value: '', text: this.$t('common.courierCompanyPlaceHolder') }]
                        this.transporterList.forEach(ele => {
                            this.transporterList1.push({
                                "value": ele.courierid,
                                "text": ele.couriername

                            })
                        })
            }, error => {
              console.error(error)
            })
		},
    resetForm() {
      this.transporter = ''; // Reset transporter value
      this.item = { value: '', text: '' }; 
      this.totalRows = 0;
      this.listReturnManifestData = [];
      this.fromDateFlt ='';
      this.toDateFlt='';
      this.manifeststatus='',
      this.returnsmanifestid='';
      this.awbno='';
      this.salesorderno='';
      // this.listfilterChannelData=[];
      this.filterstatus = '';
      if (this.user_type == 'warehouse_user') {
        this.clientid = '';
        this.clientItem={}
      }
      else if (this.user_type == 'client_user') {
        this.warehouseid = '';
        this.warehouseItem={};
      }
      else {
        this.clientid = '';
        this.clientItem={};
        this.warehouseid = '';
        this.warehouseItem={};
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getReturnsManifestData()
    },
    addNewManifest() {
      this.showReturnsManifestList = false;
      this.viewReturnsManifestList = true;
    },
    viewManifest(id){
      this.showReturnsManifestList=false;
      this.viewReturnsManifestList = false;
      this.selectedRow = id
    },
    async callParent(clientItem, warehouseItem) {
      this.showReturnsManifestList = true;
      this.getTransporterList() 
      if (clientItem.value && warehouseItem.value) {
        this.clientItem=clientItem;
        this.clientid = this.client = clientItem.value;
      await this.getWarehouseList()
        this.warehouseItem=warehouseItem;
        this.warehouseid = this.warehouseItem.value;
        this.getBinSearch();
      }
    },
    async callParent1(clientItem, warehouseItem) {
      this.showReturnsManifestList = true;
      if (clientItem.value && warehouseItem.value) {
        this.clientItem=clientItem;
        this.clientid = this.client = clientItem.value;
      await this.getWarehouseList()
        this.warehouseItem=warehouseItem;
        this.warehouseid = this.warehouseItem.value;
        this.getBinSearch();
      }
		},
    Choosetype() {
      this.show = true;
      this.download = false;
      this.getReturnManifestDataForXls(3)
    },
    getClientToken() {
      var userToken = window.localStorage.getItem('userToken');
      var myStr = userToken.replace(/"/g, '');
      return axios({
        method: 'POST',
        'url': apiUrl.api_url + 'generateClientToken',
        'data': { "clientid": this.clientid },
        headers: {
          'Authorization': 'Bearer ' + myStr,
        }
      })
        .then(result => {
          this.selectedRowData.clienttoken = result.data.token;
          this.selectedRowData.tokencreateddate = moment(new Date()).format('YYYY-MM-DD');
          this.$alertify.success("Client token fetched")
        }, error => {
          console.error(error);
        });
    },
    getClientSelectOptions(data){
        this.clientItem = {
            value: '',
            text: ''
        };
        this.listClientData = [{
            value: '',
            text: this.$t('common.clientPlaceholder')
        }];
        data.forEach(ele => {
            this.listClientData.push({
                "value": ele.clientid,
                "text": ele.clientname
            })
        })
    },
    getWarehouseSelectOptions(data){
        this.warehouseItem = {};
        this.listWarehouseData = [{
            value: '',
            text: this.$t('common.warehousePlaceholder')
        }];
        data.forEach(ele => {
            this.listWarehouseData.push({
                "value": ele.warehouseid,
                "text": ele.warehousename
            })
        })
    },
    getReturnsManifestDataSearch() {
      this.currentPage = 1;
      this.getReturnsManifestData();
    },
    dateFormat(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD');
    },
    jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = []) {
      var csvData = '';
      //Header
      if (this.title != null) {
        csvData += this.parseExtraData(this.title, '${data}\r\n')
      }
      //Fields
      for (let key in data[0]) {
        if (skipFilter.indexOf(key) == -1)
          csvData += csvfield[key] + ',';
      }
      csvData = csvData.slice(0, csvData.length - 1);
      csvData += '\r\n';
      //Data
      data.map(function (item) {
        for (let key in item) {
          if (skipFilter.indexOf(key) == -1) {
            var escapedCSV = item[key] + ''; // cast Numbers to string
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
            }
            if (escapedCSV == 'null')
              csvData += ',';
            else {
              if (dateFilter.indexOf(key) != -1)
                csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
              else
                csvData += escapedCSV + ',';
            }
          }
        }
        csvData = csvData.slice(0, csvData.length - 1);
        csvData += '\r\n';
      })
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, '${data}\r\n');
      }
      filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
      return this.export(csvData, filename, "application/csv");
      return csvData;
    },
    export(data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    getReturnsManifestData(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.listReturnManifestData = [];
      this.totalRows = 0;
      this.pageNo = this.pageCount = 0;
      if (csvCheck !== 1) {
        this.show = false;
        this.download = true;
      }
      var dataFilter = {};
      if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") == null  || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
        this.pageNo = this.pageCount = 0;
        this.listReturnManifestData = [];
        return false;
      }
      if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse") == null ||localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
        this.pageNo = this.pageCount = 0;
        this.listReturnManifestData = [];
        return false;
      }
      var fr_date = '';
      var to_date = '';
     
      if (this.fromDateFlt != '' && this.fromDateFlt != null) {
        fr_date = this.dateFormat(this.fromDateFlt) + " 00:00:00";
      }
      if (this.toDateFlt != '' && this.toDateFlt != null) {
        to_date = this.dateFormat(this.toDateFlt) + " 23:59:59";
      }
      this.isLoading = true;
      
      this.input = ({
        clientid: window.localStorage.getItem("selectedClient"),
        warehouseid: window.localStorage.getItem("selectedWarehouse"),
        manifestid: this.returnsmanifestid.trim(),
        fromdate: fr_date,
        todate: to_date,
        awbno: this.awbno,
        manifeststatus:this.manifeststatus,
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        couriercompany:this.transporter
        // csvData: csvCheck
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getReturnsManifestlist',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          this.isLoading = false;
          if (result.data.data.count > 0) {
            this.listReturnManifestData = result.data.data.data;
            this.totalRows = Number(result.data.data.count);
            if (this.totalRows > 0) {
              if (this.totalRows <= this.pageLimit) {
                this.totalPage = 1;
              } else {
                this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
              }
            } else {
              this.totalPage = 0;
            }
          }
        }, error => {
          console.error(error)
        })
    },
    startDownload() {
      this.isLoadingforxls = true;
    },
    finishDownload() {
      this.isLoadingforxls = false;
    },
    getReturnsManifestDataCSV() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var dataFilter = {};
      if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
        this.pageNo = this.pageCount = 0;
        this.listReturnManifestData = [];
        return false;
      }
      if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
        this.pageNo = this.pageCount = 0;
        this.listReturnManifestData = [];
        return false;
      }
      var fr_date = '';
      var to_date = '';
     
      if (this.fromDateFlt != '' && this.fromDateFlt != null) {
        fr_date = this.dateFormat(this.fromDateFlt) + " 00:00:00";
      }
      if (this.toDateFlt != '' && this.toDateFlt != null) {
        to_date = this.dateFormat(this.toDateFlt) + " 23:59:59";
      }
      this.isLoading = true;
      
      this.input = ({
        clientid: window.localStorage.getItem("selectedClient"),
        warehouseid: window.localStorage.getItem("selectedWarehouse"),
        manifestid: this.returnsmanifestid.trim(),
        fromdate: fr_date,
        todate: to_date,
        awbno: this.awbno,
        manifeststatus:this.manifeststatus,
        userid: this.userid,
       // couriercompany:this.transporter
        // csvData: csvCheck
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getReturnsManifestlistCSV',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
        .then(result => {
          this.isLoading = false;
          this.show = true;
            this.download = false;
            if (result.data.data.count > 0) {
              this.csvFields = {
                'id': this.$t('returnManifest.returnsManifestID'),
                'manifeststatus':  this.$t('returnManifest.manifestStatus'),
                'couriercompany': this.$t('common.courier'),
                'awbcount': this.$t('returnManifest.noofawbs'),
                'createddatetime': this.$t('consolidation.createdDatetime'),
                'closeddatetime': this.$t('inwardList.printData.closeddate')
              };
              var dateFilter = [];
              var skipFilter = ['awbno','closedby','createdby','deliveredby','deliverycontact','full_count','returntype','warehouseid'];
              this.listReturnManifestDataCsv = result.data.data.data;
              this.jsonToCSV('Returns Manifest', this.listReturnManifestDataCsv, this.csvFields, dateFilter, skipFilter);
            } else {
              if (result.data.status == true) {
                this.$alertify.success(this.$t('common.reportSizeError'));
              } else {
                this.$alertify.error(result.data.msg.message);
              }
            }
        })
    },
    getReturnManifestDataForXls(){
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.show = true;
      this.download = false;
      this.dataFilter2 = [];
      var value = '';
      var str = '';
      var fr_date = '';
      var to_date = '';
      if (this.fromDateFlt != '' && this.fromDateFlt != null) {
        fr_date = this.dateFormat(this.fromDateFlt) + " 00:00:00";
      }
      if (this.toDateFlt != '' && this.toDateFlt != null) {
        to_date = this.dateFormat(this.toDateFlt) + " 23:59:59";
      }
      this.isLoading = true;
      
      this.input = ({
        clientid: window.localStorage.getItem("selectedClient"),
        warehouseid: window.localStorage.getItem("selectedWarehouse"),
        manifestid: this.returnsmanifestid.trim(),
        fromdate: fr_date,
        todate: to_date,
        awbno: this.awbno,
        manifeststatus:this.manifeststatus,
        userid: this.userid,
       // couriercompany:this.transporter
        // csvData: csvCheck
      });
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getReturnsManifestlistCSV',
        'data': this.input,
        headers: {
          'Authorization': 'Bearer ' + myStr
        }
      })
      .then(result => {
        this.isLoading = false;
        this.show = true;
          this.download = false;
          if (result.data.data.count > 0) {
            this.listReportDataforxls = [];
            this.csvFieldsForXls[this.$t('returnManifest.returnsManifestID')] = 'id';
            this.csvFieldsForXls[this.$t('returnManifest.manifestStatus')] = 'manifeststatus';
            this.csvFieldsForXls[this.$t('common.courier')] = 'couriercompany';
            this.csvFieldsForXls[this.$t('returnManifest.noofawbs')] = 'awbcount';
            this.csvFieldsForXls[this.$t('common.createdDate')] = 'createddatetime';
            this.csvFieldsForXls[this.$t('inwardList.printData.closeddate')] = 'closeddatetime';
            this.listReportDataforxls = result.data.data.data;
          } else {
            if (result.data.status == true) {
              this.$alertify.success(this.$t('common.reportSizeError'));
            } else {
              this.$alertify.error(result.data.msg.message);
            }
          }
      })
    },
    async uploadManifestAction(id) {
			this.uploadReturnsManifest = true;
      this.manifestid = id;
		},
    chooseUpload(){
      this.selectfileFlag = true;
    },
    closeUploadModal(){
      this.cameraSection = false;
      this.fileSection = false;
      this.imageCaptured = false;
      this.selectfileFlag = false;
      this.uploadReturnsManifest = false;
    },
    uploadManifestImage(uploadType){
			if(uploadType == 'file')
			{
				this.fileSection = true;
				this.cameraSection = false;
			}
			else{
				this.fileSection = false;
				this.cameraSection = true;
			}
		},
		cameraSelected() {
            this.$refs.cameraImage.changeCamera(this.cameralist)
    },
        camerass(camlist) {
            this.cameras = camlist
        },
		captureImage() {
            this.$refs.cameraImage.pause()
            this.imageCaptured = true
        },
        resetImage() {
            this.imageCaptured = false
            this.$refs.cameraImage.resume()
        },
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
            let imageTypes = ['image/jpeg', 'image/png']
            let imageFormat = this.file.type
            let checkFormat = imageTypes.includes(imageFormat)
            if (!checkFormat) {
                this.file = null
                document.getElementById('file').value = null
                this.$alert(this.$t('grcList.imgFormatErr'))
            }
        },
        async saveImage(inputtype) {
            try {
                this.showfileselect = false
                this.showcameraselect = false
                if (!this.imageCaptured && inputtype == 'camera') {
                    this.$alert(this.$t('grcList.captureImg'))
                    return false
                } else if (!this.file && inputtype == 'file') {
                    this.$alert(this.$t('grcList.selectImg'))
                    return false
                }
                if (inputtype == 'file') {
                    var imgpath = document.getElementById('file');
                    if (!imgpath.value == "") {
                        var img = imgpath.files[0].size;
                        var imgsize = img / 1024;
                        if (imgsize > 4000) {
                            this.$alert(this.$t('grcList.imgSize4mbErr'))
                            document.getElementById('file').value = null
                            this.file=null
                            return false;
                        }
                    }
                }
                let imageString = ""
                var userToken = window.localStorage.getItem('userToken')
                var myStr = userToken.replace(/"/g, '');
                if (inputtype == "camera") {
                    imageString = this.$refs.cameraImage.capture()
                    if (!common_helper.calculateImageSize(imageString)) {
                        this.$alert(this.$t('grcList.imgSize4mbErr'))
                        this.isLoading = false
                        imageString = ""
                        return false
                    }
                } else {
                    let reader = new FileReader()
                    reader.readAsDataURL(this.file)
                    imageString = await new Promise((resolve, reject) => {
                        reader.onload = function() {
                            this.base64String = reader.result.replace("", "")
                            resolve(this.base64String)
                        }
                    })
                }
                let inputpayload = {
                    clientid : Number(localStorage.getItem("selectedClient")),
                    manifestid :  this.manifestid,
                    imagestring : imageString
                }
                this.isLoading = true

                let Result = await common_helper.getRestApiResponse('POST', 'uploadImageReturnsManifest', inputpayload, this.$alertify)

                if(Result.data.data.status == true){
                          this.$alertify.success(Result.data.data.data);
                          //this.uploadReturnsManifest = false;
                          this.isLoading = false;
                          this.cameraSection = false;
                          this.fileSection = false;
                          this.selectfileFlag = false;
                          this.isManifestDocUploaded = true;
                          this.uploadedImagesCount = Result.data.data.imageUploadedCount;
                          this.uploadedImages.push({ url: Result.data.data.imageUrl });
                          document.getElementById('file').value = null
                    }else{
                      this.isLoading = false;
                      this.cameraSection = false;
                      this.fileSection = false;
                      this.selectfileFlag = false;
                      this.isManifestDocUploaded = true;
                      this.$alertify.error(Result.data.data.data);
                    }
                } catch (err) {
                   document.getElementById('file').value = null
                    console.log(err)
                }
        },
        openImageInNewTab(imageUrl) {
          window.open(imageUrl, '_blank');
        },
        async getManifestPDF(manifestid){
          try {
            const userToken = window.localStorage.getItem('userToken')
            const myStr = userToken.replace(/"/g, '');
            this.isLoading = true;
            this.input = ({
              clientid: localStorage.getItem("selectedClient"),
              manifestid: manifestid
            });
            const result = await axios({
              method: 'POST',
              'url': apiUrl.api_url + 'generatepdfReturnsManifest',
              'data': this.input,
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myStr
              }
            })
            if (result.data && result.data.status) {
              window.open(result.data.pdfUrl, "_blank");
            }else{
              this.$alertify.error(this.$t('manifestReport.noDocumentFound'))
            }
            this.isLoading = false;
          } catch (error) {
            this.isLoading = false;
            this.$alertify.error('Some Error Occured. Please Try Again.')
            //this.$alertify.error(this.$t('apiErrors.SOME_ERR_OCCURED'))
            console.error(error)
          }
        }
        
        
  }
}



// WEBPACK FOOTER //
// ./src/views/components/returnsmanifestlist/returnsmanifest/returnsmanifest.component.js